import { TErrorMessages } from './errorMessages';
import {
  BadRequestError,
  FetchError,
  ForbiddenError,
  InternalServerError,
  MethodNotAllowedError,
  NotFoundError,
  UnauthorizedError,
} from './errorTypes';
import { WretchResponseChain } from 'wretch';
import { defaultErrorMessages } from './errorMessages';

const logErrors = import.meta.env.MODE === 'development';

export function coreErrorHandlers<T>(
  instance: WretchResponseChain<T>,
  localizedErrorMessages?: TErrorMessages | null,
): WretchResponseChain<T> {
  const errorMessages = {
    ...defaultErrorMessages,
    ...localizedErrorMessages,
  };

  return instance
    .notFound((error) => {
      logErrors && console.info('coreErrorHandlers - notFound');
      throw new NotFoundError(
        error.message,
        errorMessages.notFound.title,
        errorMessages.notFound.description,
      );
    })
    .badRequest((error) => {
      logErrors && console.info('coreErrorHandlers - badRequest');
      throw new BadRequestError(
        error.message,
        errorMessages.badRequest.title,
        errorMessages.badRequest.description,
      );
    })
    .forbidden((error) => {
      logErrors && console.info('coreErrorHandlers - forbidden');
      throw new ForbiddenError(
        error.message,
        errorMessages.forbiddenError.title,
        errorMessages.forbiddenError.description,
      );
    })
    .unauthorized((error) => {
      logErrors && console.info('coreErrorHandlers - unauthorized');
      throw new UnauthorizedError(
        error.message,
        errorMessages.unauthorized.title,
        errorMessages.unauthorized.description,
      );
    })
    .fetchError((error) => {
      logErrors && console.info('coreErrorHandlers - fetchError');
      throw new FetchError(
        error.status,
        error.message,
        errorMessages.fetchError.title,
        errorMessages.fetchError.description,
      );
    })
    .error(405, (error) => {
      logErrors && console.info('coreErrorHandlers - methodNotAllowed');
      throw new MethodNotAllowedError(
        error.message,
        errorMessages.methodNotAllowed.title,
        errorMessages.methodNotAllowed.description,
      );
    })
    .error(500, (error) => {
      logErrors && console.info('coreErrorHandlers - internalServerError');
      throw new InternalServerError(
        error.message,
        errorMessages.internalServerError.title,
        errorMessages.internalServerError.description,
      );
    });
}
